export const MAX_SIZE_IN_MB = 500;
export const BYTES_MAX_SIZE = MAX_SIZE_IN_MB * 1024 * 1024;
export const SUPPORTED_VIDEO_MIME = ['video/mp4', 'video/webm'];
export const SUPPORTED_AUDIO_MIME = ['audio/mpeg', 'audio/ogg', 'audio/aac', 'audio/wav'];
export const SUPPORTED_TYPES_FOR_CAPTION = ['mp4', 'mp3', 'ogg', 'aac'];
